import ga4 from "@/lib/tracking/ga4Core";
import { calculateValueBeforeAddingTax } from "@/lib/helpers";
import { listingToEECItemObject } from "@/lib/tracking/trackEECEvents";
import { storeWithoutExpiry, getWithoutExpiry } from "@/lib/localStorage";

const JOURNEY_DETAILS = "monthly_ad";
const STORAGE_KEY = "track_monthly_ad_shared_props";

export const trackClickToPublish = ({
  source,
  listing,
  categoriesDictionary,
}) => {
  const sharedProps = {
    listing_id: listing?.id,
    items: [listing].map((listing, index) =>
      listingToEECItemObject(listing, index, categoriesDictionary),
    ),
  };
  storeWithoutExpiry(STORAGE_KEY, sharedProps);

  const eventName = "click_interaction";
  const eventParams = {
    target: "click_here_to_publish",
    source,
    journey_details: JOURNEY_DETAILS,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackPopupInteraction = ({ source, target }) => {
  const eventName = "click_interaction";
  const eventParams = {
    target,
    source,
    journey_details: JOURNEY_DETAILS,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackMonthlyAdPurchase = ({
  value,
  transactionId,
  coupon,
  paymentType,
}) => {
  const valueWithoutTax = calculateValueBeforeAddingTax(value);
  const tax = (value - valueWithoutTax).toFixed(2);
  const sharedProps = getWithoutExpiry(STORAGE_KEY);
  const eventName = "purchase";
  const eventParams = {
    currency: "SAR",
    coupon,
    transaction_id: transactionId,
    affiliation: "aqar",
    tax: value ? tax : undefined,
    value: value ? valueWithoutTax : undefined,
    purchase_type: "monthly_ad",
    purchase_type_id: 83,
    journey_details: JOURNEY_DETAILS,
    payment_type: paymentType,
    ...(sharedProps || {}),
  };

  ga4.trackEcommerceEvent(eventName, eventParams);
};

export const trackMonthlyAdDraftClick = ({ source }) => {
  const eventName = "click_interaction";
  const eventParams = {
    target: "draft_list",
    source,
    journey_details: JOURNEY_DETAILS,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};
